import { IconButton, Link, Popover, Box, Typography } from '@material-ui/core'
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { useState } from 'react'

import { useAthleteCardMenuStyles } from './styles';

type AthleteCardMenuProps = {
  isManageableInChronoTrack: boolean
}

const AthleteCardMenu = ({ isManageableInChronoTrack }: AthleteCardMenuProps) => {
  const styles = useAthleteCardMenuStyles()

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  const onClickButton = (e: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(anchorEl ? null : e.currentTarget)
  }

  const closePopover = () => {
    setAnchorEl(null)
  }

  if (!isManageableInChronoTrack) {
    return null
  }

  return (
    <>
      <IconButton className={styles.button} size='small' onClick={onClickButton}>
        <MoreVertIcon />
      </IconButton>
      
      <Popover
        anchorEl={anchorEl}
        open={!!anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={closePopover}
      >
        <Box className={styles.popoverBox}>
          <Link
            href='https://register.chronotrack.com/user/profile'
            target='_blank'
            rel='noopener noreferrer'
            onClick={closePopover}
          >
            <Typography className={styles.popoverLink}>
              Manage Registration in ChronoTrack Live
            </Typography>
          </Link>
        </Box>
      </Popover>
    </>
  )
}

export { AthleteCardMenu }